import { CommonActions } from '../actions/common';
import { GET_CAMPAIGN_LIST_AND_SUMMARY,  MODIFY_CAMPAIGN_STATUS, RESET_CAMPAIGN_STATUS }
from "../constants/action-types";
import engagysPortalApi from '../services/engagys-api';
import { push } from 'react-router-redux';
import { DetailsActions } from '../actions/details';

const getCampaignListAndSummary = () => {
    return dispatch => {
        dispatch(CommonActions.showLoader());
        engagysPortalApi.Home.getCampaignListAndSummary()
            .then(res => {
                dispatch({
                    type: GET_CAMPAIGN_LIST_AND_SUMMARY,
                    payload: res.data
                });
            }, err => {
                dispatch(push('/login'))
            })
            .finally(() => {
                dispatch(CommonActions.hideLoader())
            })
    }
}

const redirect = () => {
    return dispatch => {
        dispatch(push('/details'));
    }
}

const changeCampaignStatus = (data, campaignId, page) => {
    return dispatch => {
        dispatch(CommonActions.showLoader());
        engagysPortalApi.Home.changeCampaignStatus(data, campaignId)
            .then(res => {
                if (page !== 'home') {
                    dispatch(DetailsActions.resetFileUploadMessage());
                    dispatch(DetailsActions.resetFormDataSave());
                    dispatch(DetailsActions.resetFileImportError());
                }
                dispatch({
                    type: MODIFY_CAMPAIGN_STATUS,
                    payload: data.status === true ? true : false
                });
                if(page === 'home') {
                    dispatch(getCampaignListAndSummary());
                }
            }, err => {
            })
            .finally(() => {
                dispatch(CommonActions.hideLoader())
            })
    }
}

const resetCampaignStatus = () => {
    return dispatch => {
        dispatch({
            type: RESET_CAMPAIGN_STATUS
        })
    }
}

const pauseAllCalls = (payload, accountId) => {
    return dispatch => {
        dispatch(CommonActions.showLoader());
        engagysPortalApi.Home.pauseAllCalls(payload, accountId)
            .then(res => {
            dispatch(getCampaignListAndSummary());
        }, err => {
        })
        .finally(() => {
            dispatch(CommonActions.hideLoader())
        })
    }
}

const createCampaign = (payload) => {
    return dispatch => {
        dispatch(CommonActions.showLoader());
        engagysPortalApi.Home.createCampaign(payload)
            .then(res => {
                dispatch(getCampaignListAndSummary());
            }, err => {
            })
            .finally(() => {
                dispatch(CommonActions.hideLoader())
            })
    }
}


export const HomeActions = {
    getCampaignListAndSummary,
    redirect,
    changeCampaignStatus,
    resetCampaignStatus,
    pauseAllCalls,
    createCampaign
}
